/**
 * ELF-CIRCLE — Services (design artboard `#4a`).
 *
 * Two discipline cards side by side, then the GEO bridge that connects them.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import ElfFooter from '../ElfFooter';
import ElfPageNav, { ElfCrumb } from '../ElfPageNav';
import ElfShell from '../ElfShell';
import { useConsult } from '../elfConsult';
import { route } from '../../../../../shared/utils';

const DISCIPLINES = [
  {
    head: 'Discipline 01',
    name: 'Marketing',
    lines: [
      'Grassroots activation',
      'Media buys & ROI strategy',
      'Brand & product placement',
      'Social/community management',
      'Event marketing',
      'SEO',
    ],
  },
  {
    head: 'Discipline 02',
    name: 'Web Development',
    lines: [
      'Landing pages to enterprise builds',
      'E-commerce',
      'Booking/scheduler integrations',
      'Ongoing site management for growing brands',
    ],
  },
];

export const ServicesPage: React.FC = () => {
  const consult = useConsult();
  return (
  <ElfShell>
    <div className="elf-page">
      <div className="elf-page__panel">
        <ElfPageNav current="/services" />
        <div style={{ padding: '18px var(--pgut) 0' }}>
          <ElfCrumb trail={[{ label: 'Home', to: '/' }, 'Services']} />
        </div>

        <div
          className="elf-page__split"
          style={{
            padding: '40px var(--pgut) 30px',
            display: 'grid',
            gridTemplateColumns: '1fr 420px',
            gap: 56,
            alignItems: 'end',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
            <span className="eyebrow">
              <i />
              Services overview
            </span>
            <h1 className="elf-page__h1">
              Two disciplines.
              <br />
              <span style={{ color: 'var(--acc-panel)' }}>One firm.</span>
            </h1>
          </div>
          <p className="wbody" style={{ fontSize: 16.5 }}>
            We are a marketing firm with an in-house development team, not a marketing firm that
            outsources the build.
          </p>
        </div>

        <div
          className="elf-page__grid2"
          style={{
            padding: '14px var(--pgut) 22px',
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: 18,
          }}
        >
          {DISCIPLINES.map((d) => (
            <div className="disc" key={d.name}>
              <span className="colhead">{d.head}</span>
              <span className="pillarname" style={{ fontSize: 36 }}>
                {d.name}
              </span>
              <span className="wbar" style={{ width: 74 }} />
              <div style={{ display: 'flex', flexDirection: 'column', marginTop: 6 }}>
                {d.lines.map((line) => (
                  <span className="sline" key={line}>
                    <i />
                    {line}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div style={{ padding: '0 var(--pgut) 52px' }}>
          <div className="bridge">
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <span className="colhead">The connective layer</span>
              <span className="pillarname" style={{ fontSize: 30 }}>
                GEO — Generative Engine Optimization
              </span>
              <span className="wbody" style={{ fontSize: 15.5, maxWidth: '70ch' }}>
                GEO (Generative Engine Optimization) and AI-search readiness, which by definition
                requires both disciplines working from one strategy, not two vendors.
              </span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, alignItems: 'flex-start' }}>
              <span className="wtag" style={{ fontSize: 12.5 }}>
                Most competitors sell it as an SEO add-on.
              </span>
              <span
                className="pillcta"
                style={{ background: 'var(--acc-panel)', color: 'var(--on-acc-panel)' }}
              >
                For us it&rsquo;s structural <span>→</span>
              </span>
            </div>
          </div>
        </div>

        <div
          className="elf-page__grid2"
          style={{
            padding: '0 var(--pgut) 72px',
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: 16,
            borderTop: '1px solid rgba(var(--panel-fg-rgb),.1)',
          }}
        >
          <Link className="nextlink" to={route('/the-trifecta')}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
              <span className="statl">Next</span>
              <span className="whead" style={{ fontSize: 20 }}>
                The Trifecta
              </span>
              <span className="wtag" style={{ fontSize: 12.5 }}>
                Which pillar your work lives in.
              </span>
            </div>
            <span className="arw">→</span>
          </Link>
          <button
              type="button"
              className="nextlink"
              onClick={() => consult?.open({ source: 'servicespage.book', title: 'Book a service' })}
            ><div style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
              <span className="statl">Start here</span>
              <span className="whead" style={{ fontSize: 20 }}>
                Book a service
              </span>
              <span className="wtag" style={{ fontSize: 12.5 }}>
                Marketing or web development — one strategy.
              </span>
            </div>
            <span className="arw">→</span>
          </button>
        </div>
      </div>
    </div>
    <ElfFooter />
  </ElfShell>
  );
};

export default ServicesPage;
